
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";

import GemeentePDFForm from "./GemeentePDFForm";
import Section from "../../common/Section";
import redirector from "../../../util/redirector";
import GemeentePDFPageHelper from "./GemeentePDFPageHelper";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";

class GemeentePDFPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.filesHelper = null;
        this.state = {
            model: null,
            fileComponents: {}
        };

        this.pageHelper = new GemeentePDFPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount(); // better way to handle unsaved changes
        this.pageHelper.init();
    };

    componentWillUnmount() {
        this.state = {
            model: null
        };
    }

    isReadyToRender = () => {
        return !!this.filesHelper && !!this.state.model;
    };

    handleOnGenereerPDF = (pdfPollingProps) => this.pageHelper.genereerPDF(pdfPollingProps);
    handleOnTerug = () => this.pageHelper.onTerug();
    handleOnIsPollingDocument(componentName, maxPollTimes) {
        return this.filesHelper.isPollingDocument(componentName, maxPollTimes);
    }

    render() {
        if (!this.isReadyToRender())
            return null;

        if (!this.state.fileComponents || !this.state.createdOnDatesForFiles) return null;

        const props = this.props;
        const downloadFileUrl = this.filesHelper.getFileDownloadUrl();
        const color = types.COLOR_BLUE;
        const model = this.state.model;

        return (
            <Section title={"PDF van de tocht " + model.tochtNaam} color={color}>
                <GemeentePDFForm
                    color={color}
                    documents={this.state.fileComponents}
                    isPollingDocument={this.handleOnIsPollingDocument}
                    onGeneratePDF={this.handleOnGenereerPDF}
                    onGaTerug={this.handleOnTerug}
                    fileDownloadUrl={downloadFileUrl}
                />
            </Section>);
    }
}

GemeentePDFPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state) {
    const bewijsstukkenFileTypes = state.settings.fileTypes[types.FileComponentNames.BEWIJSSTUKKEN_TOELATING_];
    const shouldRedirect = !state.layout.topNavTabsSet;

    return {
        bewijsstukkenFileTypes: bewijsstukkenFileTypes,
        shouldRedirect: shouldRedirect
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadGemeentePDFLayout, dispatch),
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GemeentePDFPage);